import React from "react";
import { Link } from "react-router-dom";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import {
  faArrowLeft,
  faArrowRight,
  faMoneyBillWave,
  faBoxOpen,
  faLocationDot,
  faPhone,
  faHandshake,
  faCheckCircle,
} from "@fortawesome/free-solid-svg-icons";

const HerKartCODHowTo = () => {
  return (
    <div className="min-h-screen bg-[#050816] text-white">
      <div className="mx-auto max-w-3xl px-5 py-8">
        <h1 className="text-3xl font-bold text-pink-400">
          💜 Cash On Delivery (COD)
        </h1>

        <p className="mt-2 text-slate-400">
          Safe • Simple • Trusted • Pay only after receiving your order.
        </p>

        <div className="mt-8 space-y-4">
          <div className="rounded-2xl bg-white/5 p-4">
            🛍️ <b>Step 1</b> — Browse products and add your favourites to the
            cart.
          </div>

          <div className="rounded-2xl bg-white/5 p-4">
            🛒 <b>Step 2</b> — Review your cart and proceed to checkout.
          </div>

          <div className="rounded-2xl bg-white/5 p-4">
            <FontAwesomeIcon
              icon={faLocationDot}
              className="mr-2 text-pink-400"
            />
            <b>Step 3</b> — Confirm your delivery address.
          </div>

          <div className="rounded-2xl bg-white/5 p-4">
            <FontAwesomeIcon icon={faPhone} className="mr-2 text-pink-400" />
            <b>Step 4</b> — Keep your mobile phone reachable.
          </div>

          <div className="rounded-2xl bg-white/5 p-4">
            <FontAwesomeIcon icon={faBoxOpen} className="mr-2 text-pink-400" />
            <b>Step 5</b> — The merchant prepares and packs your order.
          </div>

          <div className="rounded-2xl bg-white/5 p-4">
            🚚 <b>Step 6</b> — Your order is delivered to your doorstep.
          </div>

          <div className="rounded-2xl bg-white/5 p-4">
            <FontAwesomeIcon
              icon={faHandshake}
              className="mr-2 text-pink-400"
            />
            <b>Step 7</b> — Receive the package from the delivery partner.
          </div>

          <div className="rounded-2xl bg-white/5 p-4">
            <FontAwesomeIcon
              icon={faMoneyBillWave}
              className="mr-2 text-green-400"
            />
            <b>Step 8</b> — Pay the order amount in Cash.
          </div>

          <div className="rounded-2xl bg-white/5 p-4">
            <FontAwesomeIcon
              icon={faCheckCircle}
              className="mr-2 text-green-400"
            />
            <b>Step 9</b> — Collect your bill and enjoy your purchase.
          </div>

          <div className="rounded-2xl border border-pink-500/30 bg-pink-500/10 p-4">
            💜 <b>FoundHer Promise</b>
            <br />
            We support women entrepreneurs through a trusted local marketplace
            with simple Cash on Delivery purchases.
          </div>
        </div>

        <div className="mt-10 flex gap-4">
          <Link
            to="/herkart/cart"
            className="flex-1 rounded-2xl border border-white/10 py-3 text-center hover:bg-white/10"
          >
            <FontAwesomeIcon icon={faArrowLeft} className="mr-2" />
            Back to Cart
          </Link>

          <Link
            to="/herkart/checkout"
            className="flex-1 rounded-2xl bg-pink-600 py-3 text-center font-semibold hover:bg-pink-500"
          >
            Continue
            <FontAwesomeIcon icon={faArrowRight} className="ml-2" />
          </Link>
        </div>
      </div>
    </div>
  );
};

export default HerKartCODHowTo;
